// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1NwLt","productName":"Table_productName__6DxT5"};